module.exports = __webpack_public_path__ + "img/spartan-tenant-improvements-02.9281a655.jpg";